import React, { useState, useEffect } from "react";
import Member from "./Member";

let elements = [
  {
    name: "Luis Conde",
    description: "",
    position: "Web",
    twitter: "https://twitter.com/lcondeer",
    linkedin: "https://www.linkedin.com/in/lconder/",
    src: require("../images/team/conde.png"),
    webp: require("../images/team/conde.webp"),
  },
  {
    name: "Luis Polanco",
    description: "",
    position: "DevOps",
    twitter: "https://twitter.com/siulpolb",
    linkedin: "https://www.linkedin.com/in/siulpolb/",
    src: require("../images/team/polanco.png"),
    webp: require("../images/team/polanco.webp"),
  },
  {
    name: "Uriel Romero",
    description: "",
    position: "Frontend",
    twitter: "https://twitter.com/",
    linkedin: "https://www.linkedin.com/in/jesus-uriel-romero-lopez-67a060161/",
    src: require("../images/team/uri.png"),
    webp: require("../images/team/uri.webp"),
  },
  {
    name: "Daniel Cinto",
    description: "",
    position: "Android",
    twitter: "https://twitter.com/dansolo_dev",
    linkedin: "https://www.linkedin.com/in/daniel-cinto-c-developer",
    src: require("../images/team/dan.png"),
    webp: require("../images/team/dan.webp"),
  },
  {
    name: "Lucero Español",
    description: "",
    position: "Talent",
    twitter: "https://twitter.com/",
    linkedin: "https://www.linkedin.com",
    src: require("../images/team/lucero.png"),
    webp: require("../images/team/lucero.webp"),
  },
  {
    name: "Jonathan Hernandez",
    description: "",
    position: "Marketing",
    twitter: "https://twitter.com/Jonahzet",
    linkedin:
      "https://www.linkedin.com/in/jonathan-hern%C3%A1ndez-zetina-63867a165",
    src: require("../images/team/jonathan.png"),
    webp: require("../images/team/jonathan.webp"),
  },
  {
    name: "Rebeca Rubio",
    description: "</>",
    position: "Backend",
    twitter: "https://twitter.com/",
    linkedin: "https://www.linkedin.com/in/rebeca-rubio-quintero-0949a51b0/",
    src: require("../images/team/rebeca.png"),
    webp: require("../images/team/rebeca.webp"),
  },
  {
    name: "Noe Osorio",
    description: "",
    position: "Frontend",
    twitter: "https://twitter.com/noeosorioh",
    linkedin: "https://www.linkedin.com/in/noeosorioh/",
    src: require("../images/team/noe.png"),
    webp: require("../images/team/noe.webp"),
  },
];

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const options = [
  "marvelous",
  "magnificent",
  "multi-faceted",
  "multi-disciplinary",
  "employee",
  "respectful",
  "energetic",
  "amazing",
];

const members = [];
elements = shuffle(elements);
for (const [index, value] of elements.entries()) {
  members.push(<Member key={index} {...value} />);
}

const Team = () => {
  const [desc, setDesc] = useState("magnificent");

  useEffect(() => {
    const interval = setInterval(() => {
      let index = Math.floor(Math.random() * options.length) + 1;
      setDesc(options[index]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id={"team"} className={"section gray-bg"}>
      <div className={"container"}>
        <div className={"row justify-content-center md-m-25px-b m-40px-b"}>
          <div className={"col-lg-8 text-center"}>
            <h1 className={"h1 m-15px-b"}>Our {desc} team</h1>
            <p className={"m-0px font-2"}>Global export talent</p>
          </div>
        </div>
        <div className={"row"}>{members}</div>
      </div>
    </section>
  );
};

export default Team;
